import { render } from "./LimitReachedPopUp.vue?vue&type=template&id=60031723&scoped=true"
import script from "./LimitReachedPopUp.vue?vue&type=script&lang=js"
export * from "./LimitReachedPopUp.vue?vue&type=script&lang=js"

import "./LimitReachedPopUp.vue?vue&type=style&index=0&id=60031723&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60031723"]])

export default __exports__